// Implementation
export function mergeClassNames(...classNamesCollection) {
    const mergedClassNames = {};
    for (const classNames of classNamesCollection) {
        if (!classNames)
            continue;
        for (const entry of Object.entries(classNames)) {
            const [key, value] = entry;
            const existingValue = mergedClassNames[key];
            mergedClassNames[key] = existingValue
                ? `${existingValue} ${value}`
                : value;
        }
    }
    return mergedClassNames;
}
